import React, { useRef } from "react";
import { TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { PropTypes } from "prop-types";

const useStyles = makeStyles(theme => ({
  root: {
    color: ({ hasValue }) =>
      !hasValue ? theme.palette.text.secondary : theme.palette.text.primary
  }
}));

const FileUploadField = ({
  value,
  acceptType,
  onUpload,
  placeholder,
  helperText,
  endAdornment,
  disabled
}) => {
  const classes = useStyles({ hasValue: !!value });
  const inputRef = useRef();
  const adornmentRef = useRef();

  return (
    <div>
      <TextField
        type="button"
        value={value ? value : placeholder}
        variant="filled"
        fullWidth
        onClick={event => {
          if (!adornmentRef.current.contains(event.target)) {
            inputRef.current.click();
          }
        }}
        helperText={helperText}
        className={classes.root}
        InputProps={{
          endAdornment: <div ref={adornmentRef}>{endAdornment}</div>
        }}
        disabled={disabled}
        hiddenLabel
      />
      <input
        style={{ display: "none" }}
        accept={acceptType}
        id="file-upload-field"
        type="file"
        ref={inputRef}
        onChange={onUpload}
      />
    </div>
  );
};

export default FileUploadField;

FileUploadField.propTypes = {
  endAdornment: PropTypes.node,
  acceptType: PropTypes.string,
  onUpload: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool
};
